import { getErrorMessage } from '../../error-mapper';
import { mutationTypes } from './enums/mutation-types'
import { stages } from './enums/room-stages'

const mutations = {
  [mutationTypes.CALL_SUCCESS](state) {
    state.status = 'success'
  },
  [mutationTypes.ROOM_SUCCESS](state, response) {
    state.status = 'success'
    state.room = response
  },
  [mutationTypes.LOADING](state) {
    state.status = 'loading'
  },
  [mutationTypes.SET_TOKEN](state, token) {
    state.token = token
  },
  [mutationTypes.FAILURE](state, error) {
    state.status = 'failure'
    state.error = getErrorMessage(error)
  },
  [mutationTypes.UPDATE_ROOM_STATUS](state, status) {
    const statuses = {
      INACTIVE: stages.TO_CALL,
      CALLED: stages.CALLED,
      RESPONDED: stages.SUCCESS,
      EXPIRED: stages.ERROR
    }

    state.stage = statuses[status]
  }
}

export { mutations }